import React from 'react'
import Typography from '@mui/material/Typography'
import ContentWithLogoGrid from 'proposals/components/layout/ContentWithLogoGrid'
import View from 'proposals/components/layout/View'
import Logo from 'proposals/components/Logo'
import PageTitle from 'proposals/components/PageTitle'
import { Link as RouterLink, useParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useGetProposalById } from 'proposals/queries/useProposalByIdQuery'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const ProposalEditSuccessView: React.FC = () => {
  const { proposalId } = useParams<{ proposalId: string }>()
  const { t } = useTranslation()
  const theme = useTheme()
  const isWidescreen = useMediaQuery(theme.breakpoints.up('md'))

  // Usually gets rfp from cache because RequestForProposalView is already fetched this
  // this way we are more future proof for site refresh etc.

  const { data, isSuccess } = useGetProposalById(proposalId ?? '')

  const logoUrl =
    data && data.requestForProposal.tenantLogoUrl
      ? data.requestForProposal.tenantLogoUrl
      : '/images/default_logo.png'

  return (
    <View>
      <ContentWithLogoGrid>
        {isSuccess && isWidescreen && (
          <Box sx={{ gridArea: 'logo', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
            <Logo src={logoUrl} />
          </Box>
        )}
        <PageTitle>
          {isSuccess && !isWidescreen && (
            <Box sx={{ mb: 2 }}>
              <Logo src={logoUrl} />
            </Box>
          )}
          <Typography sx={{ lineHeight: 1, fontWeight: 'fontWeightLight' }} variant="h3">
            {t('proposal-has-been-edited-succesfully')}
          </Typography>
        </PageTitle>
        <Box sx={{ gridArea: 'content' }}>
          <Typography paragraph>{t('edit-success-text')}</Typography>
          <Button component={RouterLink} to="/vendors" variant="contained" color="primary" sx={{ color: 'common.white' }}>
            {t('to-vendor-portal')}
          </Button>
        </Box>
      </ContentWithLogoGrid>
    </View>
  )
}

export default ProposalEditSuccessView
